module.exports = __webpack_public_path__ + "static/media/let1.83e02eff.JPG";